import { apiClient } from "~/api/ApiClient";
import { PAGE_TITLES } from "~/configs/pageTitles";

import ExportsPage from "../ExportsPage/ExportsPage";

const RecommendationExports = () => (
  <ExportsPage
    exportType="Widget::RecommendationExport"
    createFn={(siteId) => apiClient.sites.recommendationExportsCreate(siteId)}
    pageTitle={PAGE_TITLES.recommendationExports}
    description="Use this page to create and download spreadsheet files of all of the recommendations for your site."
    cardTitle="Recent Exports"
    buttonLabel="Create New Export"
    successMessage="Recommendation export is generating"
    emptyText="Create your first recommendation export to get started."
  />
);

export default RecommendationExports;
